export const CASES = {
  UPDATE_JOBS: "TAP_JOBS/UPDATE_JOBS",
  UPDATE_JOBS_SEARCH_FORM: "TAP_JOBS/UPDATE_JOBS_SEARCH_FORM",
  CLEAR_JOBS: "TAP_JOBS/CLEAR_JOBS",
  CLEAR_JOB_VIEW_MODAL: "TAP_JOBS/CLEAR_JOB_VIEW_MODAL",
  CLEAR_JOB_TASKS_MODAL: "TAP_JOBS/CLEAR_JOB_TASKS_MODAL",
};
